export default __webpack_public_path__ + "static/media/6557b826-be03-4be4-b71e-6a446c0a1ef8.3969f0d5.jpeg";